const drawerWidth='15.8rem';

export const getDrawerStyle=(windowSize,isRTL=false,theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    backgroundColor: theme.custom.toolbarBase,
    // toolbarBorder is a lighter gray than the original opaque black border — branch
    // so light mode stays byte-identical to the pre-migration literal.
    borderRight: theme.palette.type === 'dark' ? `2px solid ${theme.custom.toolbarBorder}` : '2px solid #000',
    transition: theme.transitions.create('width',{
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    backgroundColor: theme.custom.toolbarBase,
    borderRight: theme.palette.type === 'dark' ? `2px solid ${theme.custom.toolbarBorder}` : '2px solid #000',
    justifyContent: 'center',
    transition: theme.transitions.create('width',{
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    drawerItem: {
      color: theme.custom.toolbarAccentContrast
    },
    overflowX: 'hidden',
    width: theme.spacing(7)+1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9)+1,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  divider: {
    backgroundColor: theme.custom.toolbarAccentContrast,
    marginBlock: 10
  },
  bottomToolbar: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-end',
    marginBottom: 20
  },
  contactIconStyle: {
    color: theme.custom.toolbarAccentContrast
  },
  logoutIconStyle: {
    width: '1.9rem'
  },
  borgerContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '2.8rem',
    height: '1.8rem !important',
    cursor: 'pointer',
    marginInlineStart: 10,
    alignSelf: 'flex-start',
    paddingBlockStart: 10,
    paddingBlockEnd: 20,
  },
  borgerLine: {
    width: '100%',
    height: '0.4rem',
    //marginBottom: 4,
    borderRadius: 2,
    backgroundColor: theme.custom.toolbarAccentContrast
  },
  drawerItemHover: {
    borderLeft: isRTL? 0:`5px solid ${theme.custom.toolbarAccentContrast}`,
    borderRight: isRTL? `5px solid ${theme.custom.toolbarAccentContrast}`:0

  },
  drawerItemTextStyle: {
    color: theme.custom.toolbarAccentContrast,
    fontSize: '1.2rem',
    fontFamily: 'Assistant'
  },
  drawerItemTextHoverStyle: {
    fontWeight: 'bold',
    color: theme.custom.toolbarAccentContrast,
    fontFamily: 'Assistant',
    fontSize: '1.2rem'
  },
  drawerItemList: {
    // toolbarHoverBg is a different hue (blue-gray) than the original translucent
    // gray — branch so light mode stays byte-identical to the pre-migration literal.
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.toolbarHoverBg : 'rgba(242, 242, 242, 0.83)'
  },
  drawerItemInnerTextStyle: {
    color: theme.custom.toolbarTextSecondary,
    marginInlineStart: 10,
    fontSize: '0.9rem',
    fontFamily: 'Assistant'
  },
  drawerItemInnerTextHoverStyle: {
    color: theme.custom.toolbarTextSecondary,
    marginInlineStart: 10,
    fontSize: '0.9rem',
    fontWeight: 'bold',
    fontFamily: 'Assistant'
  },
})